import React, { PropTypes } from "react";
import axios from "axios";
import Modal from "react-bootstrap/lib/Modal";
import LoadingSpinner from "../../feature/loadingSpinner"

class Accordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false, policies: [], showDialog: false, src:null, policyName: null, noOfPolicies: <LoadingSpinner/>,
      showIAcceptButton: "none", showCommonAcceptButton: null};
    this.togglePanel = this.togglePanel.bind(this);
    this.getPoliciesUnderPolicyGroup = this.getPoliciesUnderPolicyGroup.bind(this);
  }

  getPoliciesUnderPolicyGroup(id) {
    let request = {
      department: this.props.department,
      vertical: this.props.vertical,
      policyGroupId: id
    };

    axios
      .get(
        process.env.REQ_URL +
          "/policies/getPoliciesForEmployee?q=" +
          JSON.stringify(request),
        {
          withCredentials: true,
          headers: { "X-Requested-With": "XMLHttpRequest" }
        }
      )
      .then(response => {
        this.setState({ policies: response.data.data, requested: true });
        if(response.data.data.length === 0) {
            this.setState({noOfPolicies: "No policies under this policy group"});
        } else {
            for (let i = 1; i <= response.data.data.length; i++) {
                if(response.data.data[i-1].status === "accepted") {
                    this.setState({showIAcceptButton: null, showCommonAcceptButton: "none"});
                }
            }
        }
      })
      .catch(error => {
        console.log("error while calling api /policies/getPoliciesForEmployee");
      });
  }

  togglePanel() {
    if (!this.state.requested && !this.state.open) {
      this.getPoliciesUnderPolicyGroup(this.props.groupId);
    }
    this.setState(({ open }) => ({
      open: !open
    }));
  }

  render() {
    return (
        <div>
          <div className="accordion">
            <div
              className={`accordion_heading${
                this.state.open ? " accord_active" : ""
              }`}
              onClick={this.togglePanel}
            >
              {this.props.header}
              <i className="arrow" />
            </div>
            <div className="accordion_panel">
              <table className="table" cellPadding="5px" cellSpacing="0" border="0">
                <tbody>
                {this.state.policies.length === 0 ? this.state.noOfPolicies :
                     <div>{this.state.policies.map((node, index) => {
                    if (node.status === "accepted") {
                        const t = new Date( node.acceptedTime );
                        const formatted = t.toDateString();
                      return (
                          <div style={{marginBottom:"2px"}}>
                        <tr>
                          <td style={{ width: "50%" }}>
                              <a onClick= { () => {
                                   this.setState({src: node.policyLink, policyName: node.policyName, showDialog: true});
                              }}> {node.policyName}</a>
                          </td>
                          <td style={{ width: "30%", textAlign: "center" }}>
                            V{node.version}
                          </td>
                          <td style={{ textAlign: "center", width: "200px" }}>
                              {formatted}
                          </td>
                        </tr>
                           </div>

                      );
                    } else {
                      let request = {
                        policiesId: node.policiesId,
                        policyGroupId: node.policyGroupId,
                        policyId: node.policyId,
                        version: node.version
                      };
                      return (
                          <div style={{marginBottom:"2px"}}>
                        <tr>
                            <td style={{ width: "50%" }}>
                                <a onClick= { () => this.setState({src: node.policyLink, policyName: node.policyName, showDialog: true}) }>
                                    {node.policyName}</a>
                            </td>
                          <td style={{ width: "30%", textAlign: "center" }}>
                            V{node.version}
                          </td>
                          <td style={{ textAlign: "center", width: "200px" }}>
                            <button
                              className="btn btn-primary accordion_cta"
                              style={{display: this.state.showIAcceptButton }}
                              onClick={() => {
                                axios
                                  .post(
                                    process.env.REQ_URL +
                                      "/policies/savePolicyEmployeeMapping",
                                    { data: request },
                                    {
                                      withCredentials: true,
                                      headers: {
                                        "X-Requested-With": "XMLHttpRequest"
                                      }
                                    }
                                  )
                                  .then(response => {
                                    this.setState({
                                      policies: this.state.policies.reduce(
                                        (acc, each) => {
                                          if (each.policyId === node.policyId) {
                                            acc.push(Object.assign(each, response.data.data));
                                          } else {
                                            acc.push(each);
                                          }
                                          return acc;
                                        },
                                        []
                                      )
                                    });
                                  })
                                  .catch(error => {});
                              }}
                            >
                              {" "}
                                 I Acknowledge
                            </button>
                          </td>
                        </tr>
                          </div>
                      );
                    }
                     })} <p className="btntable" style={{display: this.state.showCommonAcceptButton, margin:"auto" }}>I acknowledge having read and understood contents of the policies, enlisted in this section.</p>
                         <button
                         className="btn btn-primary accordion_cta btntable"
                         style={{display: this.state.showCommonAcceptButton, margin:"auto"}}
                         onClick={() => {
                             this.state.policies.map((node, index) => {
                                 let request = {
                                     policiesId: node.policiesId,
                                     policyGroupId: node.policyGroupId,
                                     policyId: node.policyId,
                                     version: node.version
                                 };
                             axios
                                 .post(
                                     process.env.REQ_URL +
                                     "/policies/savePolicyEmployeeMapping",
                                     { data: request },
                                     {
                                         withCredentials: true,
                                         headers: {
                                             "X-Requested-With": "XMLHttpRequest"
                                         }
                                     }
                                 )
                                 .then(response => {
                                     this.setState({
                                         policies: this.state.policies.reduce(
                                             (acc, each) => {
                                                 if (each.policyId === node.policyId) {
                                                     acc.push(Object.assign(each, response.data.data));
                                                 } else {
                                                     acc.push(each);
                                                 }
                                                 return acc;
                                             },
                                             []
                                         ), showCommonAcceptButton: "none"
                                     });
                                 })
                                 .catch(error => {});
                         })}}
                     >
                         {" "}
                         I Acknowledge
                     </button> </div>  }
                </tbody>
              </table>
            </div>
          </div>

            <Modal
                bsSize="large"
                show={this.state.showDialog}
                onHide={() => {
                    this.setState({ showDialog: false });
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{this.state.policyName}&nbsp;</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe
                        style={{ marginTop: "-50px" }}
                        src={this.state.src}
                        width="850"
                        height="500"
                    />
                        <a href= {this.state.src} download={true}>Download</a>
                </Modal.Body>
            </Modal>

        </div>
    );
  }
}

Accordion.proptypes = {};

export default Accordion;



/** WEBPACK FOOTER **
 ** ./src/components/common/Accordion.js
 **/